import React, {useState} from 'react';
// import Picker from 'emoji-picker-react';
import {Picker} from 'emoji-mart'
import 'emoji-mart/css/emoji-mart.css'
import assets from "../../../util/assets";
import "./index.css";
import PropTypes from "prop-types";

ChatWindowSmileyDropdown.propTypes = {
    setChosenEmoji: PropTypes.func.isRequired,
};

function ChatWindowSmileyDropdown(props) {
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const toggle = () => setPopoverOpen(!popoverOpen);
    const onEmojiClick = (emojiObject, event) => {
        props.setChosenEmoji(emojiObject);
        toggle();
    };

    return (
        <div>
            <img
                onClick={toggle}
                className="cursor-pointer padding-16"
                src={popoverOpen ? assets.messaging.bottom.smile_active : assets.messaging.bottom.smile_inactive}
                id={`chat-window-smiley`}/>

            {
                popoverOpen &&
                <Picker
                    native
                    title='Pick your emoji…'
                    emoji='point_up'
                    onClick={onEmojiClick}
                    style={{ position: 'absolute', bottom: '30px', right: '0px' }}
                />
            }

        </div>
    );
}

export default ChatWindowSmileyDropdown;